import {css, unsafeCSS} from 'lit';
import {sbkCoreBreakpointLg} from '@/tokens/variables.js'


const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);

export const datepickerStyles = css`
    :host {
        position: relative;

        --select__border: var(--_select__border, var(--sbkSelectBorderOnLightEnabled));
        --select__color: var(--_select__color, var(--sbkSelectColorFgColorOnLightDefault));
        --select__bg: var(--_select__bg, var(--sbkSelectColorBgColorOnLightTriggerEnabled));
        --select__bg--active: var(--_select__bg--active, var(--sbkSelectColorBgColorOnLightTriggerActive));
        --select__bg--hover: var(--_select__bg--hover, var(--sbkSelectColorBgColorOnLightTriggerHover));
        --select__bg--focus: var(--_select__bg--focus, var(--sbkSelectColorBgColorOnLightTriggerFocus));
        --select__border--active: var(--_select__border--active, var(--sbkSelectBorderOnLightActive));
        --select__border--focus: var(--_select__border--focus, var(--sbkSelectBorderOnLightFocus));
        --select__border--hover: var(--_select__border--hover, var(--sbkSelectBorderOnLightHover));
    }

    .input--only {
        display: none;
    }

    .datepicker {
        box-sizing: border-box;
        max-width: var(--sbkDatePickerSizingFlyoutFlyoutMaxWidth);
        min-width: var(--sbkDatePickerSizingFlyoutFlyoutMinWidth);
        position: absolute;
        margin-top: var(--sbkDatePickerSizingMd);
        right: 0;
        z-index: 1;
        background: var(--sbkDatePickerColorBgColorOnLightFlyoutEnabled);
        padding: var(--sbkDatePickerSpacingTriggerXs);
        box-shadow: var(--sbkDatePickerFlyoutOnLightShadow);
        border-radius: var(--sbkDatePickerBorderRadiusDefault);
        border: 0;
    }

    .datepicker__above {
        bottom: calc(60px + var(--sbkDatePickerSizingMd));
        margin-top: 0;

        @media all and (max-width: ${breakpointLg}) {
            bottom: calc(48px + var(--sbkDatePickerSizingMd));
        }
    }

    .input__container {
        position: relative;
    }

    .datepicker-icon {
        position: absolute;
        right: calc(var(--sbkInput2xs) - 4px);
        top: calc(var(--sbkInput2xs) - 4px);
        background-color: transparent;
        color: var(--input__color);
        outline: 2px solid transparent;
        outline-offset: var(--sbkButtonBorderGapFocus);
        border-radius: var(--sbkButtonBorderRadiusDefault);
        border: none;
        cursor: pointer;
        text-decoration: none;
        fill: currentColor;

        .input__wrapper--error & {
            color: var(--input__color--error);
        }

        @media all and (min-width: ${breakpointLg}) {
            right: calc(var(--sbkInput2xs) - 2px);
            top: calc(var(--sbkInput2xs) + 2px);
        }
    }

    table {
        width: 100%;
        border-collapse: collapse;
        transition: transform 0.3s ease, opacity 0.3s ease;
    }

    th {
        color: var(--sbkColorContentFgColorOnLightDefault);
        font: var(--sbkDatePickerTypographyFlyoutSm);
    }

    th, td {
        width: var(--sbkDatePickerSizingFlyoutWeekDayTextFixedWidth);
        text-align: center;
    }

    .select-wrapper {
        box-sizing: border-box;
        margin-bottom: var(--sbkDatePickerSpacingTriggerXs);
    }

    .datepicker-navigation {
        text-align: center;
    }

    select {
        box-sizing: border-box;
        margin: var(--sbkDatePickerSpacingFlyoutSelectAreaGap);
        background-color: var(--select__bg);
        border: var(--sbkSelectBorderOnLightEnabled);
        border-radius: var(--sbkSelectBorderRadiusDefault);
        color: var(--select__color);
        font: var(--sbkSelectTypographySelectSmallTextSm);
        outline: transparent;
        outline-offset: var(--sbkSelectBorderGapFocus);
        padding: var(--sbkInput2xs) 32px var(--sbkInput2xs) 16px;
        position: relative;
        cursor: pointer;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        min-width: 100%;


        @media all and (min-width: ${breakpointLg}) {
            font: var(--sbkSelectTypographySelectLargeTextLg);
            padding: var(--sbkInputXs) 32px var(--sbkInputXs) var(--sbkInputXs);
        }

        &:active {
            background-color: var(--select__bg--active);
            border: var(--select__border--active);
        }

        &:focus,
        &:focus-visible {
            background-color: var(--select__bg--focus);
            outline: var(--select__border--focus);
        }

        @media (hover: hover) and (pointer: fine) {
            &:hover:not(:focus) {
                background-color: var(--select__bg--hover);
                border: var(--select__border--hover);
            }
        }
    }

    .select-wrapper {
        width: 100%;
        box-sizing: border-box;
    }

    .select-container {
        box-sizing: border-box;
        position: relative;
        display: inline-block;
    }

    .select-container--month {
        box-sizing: border-box;
        max-width: 54%;
        margin-right: 8px;
    }

    .select-container--year {
        box-sizing: border-box;
    }

    .select-icon {
        position: absolute;
        color: var(--select__color);
        right: 8px;
        top: 21px;
        pointer-events: none;
        @media all and (min-width: ${breakpointLg}) {
            top: 26px;
        }
    }

    .datepicker__calendar-item.selected::part(button) {
        background-color: var(--sbkRoundButtonBgColorOnLightActive);
        border: var(--sbkButtonBorderOnLightActive);
        color: var(--sbkRoundButtonBgColorOnDarkEnabled);
    }

    .datepicker__calendar-item.today::part(button) {
        border: var(--round-button__border-color--disabled);
    }

    .datepicker-navigation {
        .prev {
            margin-right: var(--sbkDatePickerSpacingFlyoutButtonsAreaInsetLeftRightBottom);
        }
    }

    .datepicker__calendar-item--not-current::part(button) {
        background-color: var(--round-button__bg--disabled);
        color: var(--round-button__color--disabled);
    }

    #datepicker-dialog {
        overflow: hidden;
        --_round-button__color: var(--sbkRoundButtonBgColorOnDarkEnabled);
        --_round-button__color--hover: var(--sbkRoundButtonFgColorOnLightDefault);
        --_round-button__color--focus: var(--sbkRoundButtonBgColorOnDarkEnabled);
        --_round-button__color--disabled: var(--sbkRoundButtonFgColorOnLightDisabled);
        --_round-button__color--error: var(--sbkRoundButtonFgColorOnDarkDefault);
        --_round-button-icon-only__color: var(--sbkRoundButtonBgColorOnLightEnabled);

        --_round-button__bg--hover: var(--sbkRoundButtonBgColorOnLightHover);
        --_round-button__bg--focus: var(--sbkRoundButtonBgColorOnLightFocus);
        --_round-button__bg--disabled: var(--sbkRoundButtonBgColorOnLightDisabledTransparent);
        --_round-button__bg--error: var(--sbkRoundButtonBgColorOnLightError);
        --_round-button-icon-only__bg: var(--sbkRoundButtonBgColorOnLightEnabledTransparent);

        --_round-button__border-color: var(--sbkRoundButtonBorderOnLightMarked);
        --_round-button__border-color--hover: var(--sbkButtonBorderOnLightHover);
        --_round-button__border-color--focus: var(--sbkButtonBorderOnLightFocus);
        --_secondary-button__border-color--disabled: var(--sbkButtonBorderOnLightDisabled);
        --_secondary-button__border-color--error: var(--sbkButtonBorderOnLightDisabled);

        --_round-button__bg--active: var(--sbkRoundButtonBgColorOnLightMarked);
        --_round-button__border-color--active: var(--sbkRoundButtonBorderOnLightMarked);
        --_round-button__color--active: var(--sbkRoundButtonFgColorOnLightDefault);
    }

    /* Keyframes for slide-in and slide-out animations */

    .slide-out-left {
        transform: translateX(-100%);
        opacity: 0;
    }

    .slide-out-right {
        transform: translateX(100%);
        opacity: 0;
    }

    .slide-in-left {
        transform: translateX(0);
        opacity: 1;
    }

    .slide-in-right {
        transform: translateX(0);
        opacity: 1;
    }

`;
